import { change } from 'redux-form'
import { createAction } from 'redux-actions'
import { EMAIL_SIGN_UP_FORM } from './constants'

export const resetFormFields = fields => dispatch =>
  fields
    .forEach(field => dispatch(change(EMAIL_SIGN_UP_FORM, field, null)))

export const subscriptionCompleted = createAction('EMAIL_SIGN_UP/SUBSCRIPTION_SUCCEED')
